<template>
  <div class="releases">
    <div v-for="(release, releaseIndex) in releases" :key="release.id">
      <SandwichRelease v-if="release.type == 'sandwich'" :release="release" :releaseIndex="releaseIndex" :timeslots="timeslots[releaseIndex]"/>
      <MerchRelease v-else :release="release" :timeslots="timeslots[releaseIndex]"/>
    </div>
  </div>
</template>

<script>
import ReleaseService from '@/services/ReleaseService.js'
import SandwichRelease from '@/components/SandwichRelease.vue'
import MerchRelease from '@/components/MerchRelease.vue'
import Vue from 'vue'

export default {
  components: {
    SandwichRelease,
    MerchRelease
  },
  props: {
    privateRelease: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      releases: [],
      timeslots: []
    }
  },
  mounted() {
    ReleaseService.getReleases(this.privateRelease, this.$route)
      .then(response => {
        this.releases = response.data
        for (let i = 0; i < this.releases.length; i++) {
          Vue.set(this.releases[i], 'showDescription', false)
        }
        this.releases.forEach(data => {
          this.timeslots.push(this.generateTimeslots(data))
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    generateTimeslots: function(data) {
      var results = []

      data.timeslots.forEach(timeslot => {
        results.push({
          id: timeslot.id,
          release_id: timeslot.release_id,
          start_time: timeslot.start_time,
          end_time: timeslot.end_time,
          available_menu_items: timeslot.available_menu_items,
          visible: false,
          confirmationOpen: false
        })
      })

      return results
    }
  }
}
</script>

<style lang="scss">
.time-slot {
  margin: 1em;
  padding: 1em;
  border: black;
  border-width: 0.05em;
  border-style: solid;
}

.time-slot:active:not(:focus-within) {
  background-color: gray;
}

.menu_item-name {
  display: block;
  font-size: 3.5em;
  font-weight: 500;
  text-align: center;
}

.menu_item-description {
  font-size: 2em;
  font-weight: light;
  text-align: center;
}
</style>
